<template>
  <RecycleScroller
    class="scroll-container grid"
    @scroll-end="loadMore"
    :items="items"
    :item-size="160"
    :item-secondary-size="160"
    :grid-items="4"
  >
    <template v-slot="{ item }">
      <v-skeleton-loader
        v-if="isLoading"
        height="200"
        width="200"
        max-height="200"
        max-width="200"
        type="video"
      />

      <grid-tile
        v-else-if="item.src"
        @scroll-to-message="() => scrollToMessage(item.messageId)"
      >
        <video height="150" width="150" controls>
          <source :src="item.src" />
        </video>
      </grid-tile>

      <div
        v-else-if="item.placeholder"
        style="height: 150px; width: 150px"
      ></div>
      <div
        class="grid-month-tile text-h5"
        v-else-if="item.month"
        style="height: 150px; width: 150px"
      >
        {{ item.month }}<br />{{ item.year }}
      </div>
    </template>
  </RecycleScroller>
</template>

<script>
import { RecycleScroller } from 'vue-virtual-scroller_1_1_2';
import GridTile from './GridTile.vue';

export default {
  name: 'FileGrid',

  components: {
    RecycleScroller,
    GridTile,
  },

  props: {
    items: Array,
    isLoading: Boolean,
    loadMore: Function,
  },

  methods: {
    scrollToMessage(messageId) {
      this.$emit('scroll-to-message', messageId);
    },
  },
};
</script>

<style lang="scss">
.scroll-container.grid {
  video {
    cursor: pointer;
  }

  .grid-month-tile {
    padding-top: 90px;
  }
}
</style>
